import * as React from "react";
import { useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

import { FooterStyles } from "./FooterStyles";
import { useTheme } from "../../../providers/ThemeContext";
import { useI18n } from "../../../languages/providers/I18nProvider";
import { footerKeys, footerData } from "./FooterContent";
import styles from "./footer.module.css";
import { useLangPath } from "../../../hooks/useLangPath";

const FooterHelp = () => {
  const { theme } = useTheme();
  const { t } = useI18n();
  const navigate = useNavigate();
  const s = FooterStyles(theme);
  const lp = useLangPath();

  return (
    <div>
      <div style={s.colTitle}>{t(footerKeys.helpTitle)}</div>

      {footerData.help.map((item) => {
        return (
          <HashLink
            key={item.key}
            to={lp(item.to)}
            smooth
            className={styles.footerLink}
          >
            {t(item.key)}
          </HashLink>
        );
      })}
    </div>
  );
};

export default FooterHelp;
